import React from 'react'
import {Fragment} from 'react'
import classnames from 'classnames'

import {SlotCard} from '../../../ui/cards/SlotCard'
import {Accordion, AccordionItem, Text} from '../../../ui/components'
import {THeaderBlock} from '../../types'
import {ListLink} from './ListLink'

import styles from './styles.module.css'

type TLinkListProps = THeaderBlock & {
  withDivider?: boolean
  className?: string
}

export function LinkList({caption, items, className, withDivider = true}: TLinkListProps) {
  return (
    <SlotCard className={className}>
      {caption && (
        <Text tag="p" kind="caption" color="textGrey" className={styles.linkListCaption}>
          {caption}
        </Text>
      )}
      {items &&
        items.map((item, index) =>
          item?.linkList?.length ? (
            <Fragment key={index.toString()}>
              {withDivider && index !== 0 && (
                <hr className={classnames(styles.linkListItemHr, {[styles.mobile]: item.mobileOnly})} />
              )}
              <Accordion stretchToFillContainer key={index.toString()} className={styles.accordion}>
                <AccordionItem
                  header={item.text}
                  headerTag="span"
                  icon={item?.icon}
                  badge={item?.badge}
                  caption={item?.caption}
                  captionCN={styles.caption}
                  descriptionCN={styles.accordionListContainer}
                  headerKind="body"
                  className={styles.accordionItemContainer}
                  headerClassName={styles.accordionItem}
                >
                  {item.linkList.map((link, index) => (
                    <ListLink
                      key={index.toString()}
                      item={link}
                      index={index}
                      withDivider={false}
                      className={styles.linkInAccordion}
                    />
                  ))}
                </AccordionItem>
              </Accordion>
            </Fragment>
          ) : (
            <ListLink key={index.toString()} item={item} index={index} withDivider={withDivider} />
          ),
        )}
    </SlotCard>
  )
}
